import { withRouter } from 'react-router-dom';
import FlowContainer from './FlowContainer';

export default withRouter(FlowContainer);
